import _ from 'lodash';
import * as Constants from "../utils/constants"

export const useQuill = () => {
    const checkFirstTextBoldFormat = (currentFormats, currentContents) => {
        let hasBold = false;
        if (currentFormats.bold) {
            hasBold = true;
        } else if (currentContents && currentContents.ops && currentContents.ops.length > 0) {
            let firstItem = currentContents.ops.find(item => item.insert !== "\n");
            if (firstItem.attributes?.bold === true)
                hasBold = true;
        }
        return hasBold;
    }


    const checkFirstTextItalicFormat = (currentFormats, currentContents) => {
        let hasItalic = false;
        if (currentFormats.italic) {
            hasItalic = true;
        } else if (currentContents && currentContents.ops && currentContents.ops.length > 0) {
            let firstItem = currentContents.ops.find(item => item.insert !== "\n");
            if (firstItem.attributes?.italic === true)
                hasItalic = true;
        }
        return hasItalic;
    }

    const checkFirstTextUnderlineFormat = (currentFormats, currentContents) => {
        let hasUnderline = false;
        if (currentFormats.underline) {
            hasUnderline = true;
        } else if (currentContents && currentContents.ops && currentContents.ops.length > 0) {
            let firstItem = currentContents.ops.find(item => item.insert !== "\n");
            if (firstItem.attributes?.underline === true)
                hasUnderline = true;
        }
        return hasUnderline;
    }

    return {
        getQuill: (id) => {
            const element = document.getElementById(id);
            if (element && element.__quill) {
                return element.__quill;
            }
            return null;
        },
        getAndCheckIndex: (quill, index) => {
            const length = quill.getLength();
            if (index === null || index === undefined) return length;
            if (index > length || index < 0) return length;
            return index;
        },
        insideEmptyParagraph: (quill, index) => {
            const [line, offset] = quill.getLine(index);
            return (line && line.length() === 1);
        },
        atStartOfParagraph: (quill, index) => {
            const [line, offset] = quill.getLine(index);
            if (!line) return false;
            return (offset === 0);
        },
        atEndOfParagraph: (quill, index) => {
            const [line, offset] = quill.getLine(index);
            if (!line) return false;
            return offset === line.length() - 1;
        },
        insertQuillText: (quill, text, index) => {
            const htmlContent = quill.clipboard.convert(text);
            if (htmlContent.ops && Array.isArray(htmlContent.ops)) {
                let currentIndex = index;
                htmlContent.ops.forEach((content, contentIndex) => {
                    const newFormats = content.attributes ? content.attributes : {};

                    const regexOneOrMultiLineBreak = /^\n+$/;
                    const isLineBreak = regexOneOrMultiLineBreak.test(content.insert);

                    if (!newFormats.bold && !isLineBreak) {
                        newFormats.bold = false;
                    }
                    if (!newFormats.italic && !isLineBreak) {
                        newFormats.italic = false;
                    }
                    if (!newFormats.underline && !isLineBreak) {
                        newFormats.underline = false;
                    }
                    if (newFormats.fs === "") {
                        delete newFormats.fs;
                    }
                    if (newFormats.fontfamily === "") {
                        delete newFormats.fontfamily;
                    }

                    if (isLineBreak) {
                        if (newFormats.list) {
                            newFormats.align = false;
                        } else {
                            newFormats.list = false;
                        }
                    } else {
                        if (newFormats.list) {
                            delete newFormats.list;
                        }
                        if (newFormats.align) {
                            delete newFormats.align;
                        }
                    }

                    if (contentIndex === htmlContent.ops.length - 1 && isLineBreak) {
                        quill.formatLine(currentIndex, 0, newFormats, Constants.quillApiSource.user);
                        if (content.insert?.length > 1) {
                            quill.insertText(currentIndex, "\n".repeat(content.insert.length - 1), newFormats, Constants.quillApiSource.user);
                        }
                    } else {
                        quill.insertText(currentIndex, content.insert ? content.insert : '', newFormats, Constants.quillApiSource.user);
                    }

                    currentIndex = currentIndex + content.insert.length;
                })
            }
        },
        setBold: (quill, setFormatMenuBar) => {
            if (!quill) {
                return;
            }

            const selection = quill.getSelection();
            if (!selection) {
                return;
            }

            const currentFormats = quill.getFormat();
            if (!currentFormats) {
                return;
            }

            const currentContents = quill.getContents(selection.index, selection.length);

            const hasBold = checkFirstTextBoldFormat(currentFormats, currentContents);

            if (hasBold) {
                quill.format(Constants.quillFormatKeywords.bold, false);
                setFormatMenuBar(prev => ({
                    ...prev,
                    boldButtonState: Constants.formatButtonState.enabledAndUnfocused,
                }))
            } else {
                quill.format(Constants.quillFormatKeywords.bold, true);
                setFormatMenuBar(prev => ({
                    ...prev,
                    boldButtonState: Constants.formatButtonState.enabledAndFocused,
                }))
            }

            // Trigger custom event to save state after formatting change
            setTimeout(() => {
                const event = new CustomEvent('webeditor-after-format-change');
                window.dispatchEvent(event);
            }, 10);
        },
        setItalic: (quill, setFormatMenuBar) => {
            if (!quill) {
                return;
            }

            const selection = quill.getSelection();
            if (!selection) {
                return;
            }

            const currentFormats = quill.getFormat();
            if (!currentFormats) {
                return;
            }

            const currentContents = quill.getContents(selection.index, selection.length);

            const hasItalic = checkFirstTextItalicFormat(currentFormats, currentContents);

            if (hasItalic) {
                quill.format(Constants.quillFormatKeywords.italic, false);
                setFormatMenuBar(prev => ({
                    ...prev,
                    italicButtonState: Constants.formatButtonState.enabledAndUnfocused,
                }))
            } else {
                quill.format(Constants.quillFormatKeywords.italic, true);
                setFormatMenuBar(prev => ({
                    ...prev,
                    italicButtonState: Constants.formatButtonState.enabledAndFocused,
                }))
            }

            // Trigger custom event to save state after formatting change
            setTimeout(() => {
                const event = new CustomEvent('webeditor-after-format-change');
                window.dispatchEvent(event);
            }, 10);
        },
        setUnderline: (quill, setFormatMenuBar) => {
            if (!quill) {
                return;
            }

            var selection = quill.getSelection();
            if (!selection) {
                return;
            }

            var currentFormats = quill.getFormat();
            if (!currentFormats) {
                return;
            }

            const currentContents = quill.getContents(selection.index, selection.length);

            const hasUnderline = checkFirstTextUnderlineFormat(currentFormats, currentContents);

            if (hasUnderline) {
                quill.format(Constants.quillFormatKeywords.underline, false);
                setFormatMenuBar(prev => ({
                    ...prev,
                    underlineButtonState: Constants.formatButtonState.enabledAndUnfocused,
                }))
            } else {
                quill.format(Constants.quillFormatKeywords.underline, true);
                setFormatMenuBar(prev => ({
                    ...prev,
                    underlineButtonState: Constants.formatButtonState.enabledAndFocused,
                }))
            }

            // Trigger custom event to save state after formatting change
            setTimeout(() => {
                const event = new CustomEvent('webeditor-after-format-change');
                window.dispatchEvent(event);
            }, 10);
        },
        alignLeft: (quill) => {
            if (!quill) {
                return;
            }

            const selection = quill.getSelection();
            if (!selection) {
                return;
            }

            const format = quill.getFormat();
            if (!format) {
                return;
            }

            if (format.align) {
                quill.format(Constants.quillFormatKeywords.align, false);
            } else {
                quill.format(Constants.quillFormatKeywords.align, Constants.quillFormatKeywords.alignLeft);
                quill.format(Constants.quillFormatKeywords.list, false);
            }
        },
        alignRight: (quill) => {
            if (!quill) {
                return;
            }

            const selection = quill.getSelection();
            if (!selection) {
                return;
            }

            const format = quill.getFormat();
            if (!format) {
                return;
            }

            if (format.align === Constants.quillFormatKeywords.alignRight) {
                quill.format(Constants.quillFormatKeywords.align, false);
            } else {
                quill.format(Constants.quillFormatKeywords.align, Constants.quillFormatKeywords.alignRight);
                quill.format(Constants.quillFormatKeywords.list, false);
            }
        },
        alignCenter: (quill) => {
            if (!quill) {
                return;
            }

            const selection = quill.getSelection();
            if (!selection) {
                return;
            }

            const format = quill.getFormat();
            if (!format) {
                return;
            }

            if (format.align === Constants.quillFormatKeywords.alignCenter) {
                quill.format(Constants.quillFormatKeywords.align, false);
            } else {
                quill.format(Constants.quillFormatKeywords.align, Constants.quillFormatKeywords.alignCenter);
                quill.format(Constants.quillFormatKeywords.list, false);
            }
        },
        alignJustify: (quill) => {
            if (!quill) {
                return;
            }

            const selection = quill.getSelection();
            if (!selection) {
                return;
            }

            const format = quill.getFormat();
            if (!format) {
                return;
            }

            if (format.align === Constants.quillFormatKeywords.alignJustify) {
                quill.format(Constants.quillFormatKeywords.align, false);
            } else {
                quill.format(Constants.quillFormatKeywords.align, Constants.quillFormatKeywords.alignJustify);
                quill.format(Constants.quillFormatKeywords.list, false);
            }
        },
        setUnorderedList: (quill) => {
            if (!quill) {
                return;
            }

            const selection = quill.getSelection();
            if (!selection) {
                return;
            }

            const format = quill.getFormat();
            if (!format) {
                return;
            }

            if (format.list === Constants.quillFormatKeywords.bullet) {
                quill.format(Constants.quillFormatKeywords.list, false);
            } else {
                createUnorderedList(quill);
            }
        },
        setNumberedList: (quill) => {
            if (!quill) {
                return;
            }

            const selection = quill.getSelection();
            if (!selection) {
                return;
            }

            const format = quill.getFormat();
            if (!format) {
                return;
            }

            if (format.list === Constants.quillFormatKeywords.ordered) {
                quill.format(Constants.quillFormatKeywords.list, false);
            } else {
                createNumberedList(quill);
            }
        },
        createListByKeyShortcut: (quill, range, context) => {
            if (!quill) {
                return true;
            }

            const prefixLength = context.prefix.length;
            if (context.offset > prefixLength) {
                return true;
            }

            switch (context.prefix.trim()) {
                case '[]': case '[ ]':
                    break;
                case '[x]':
                    break;
                case '-': case '*':
                    quill.deleteText((range.index - prefixLength), prefixLength);
                    createUnorderedList(quill);
                    break;
                default:
                    quill.deleteText((range.index - prefixLength), prefixLength);
                    createNumberedList(quill);
                    break;
            }
        },
        changeFontSize: (quill, fontSize, setFormatMenuBar) => {
            setFontSize(quill, fontSize, setFormatMenuBar);
        },
        increaseFontSize: (quill, setFormatMenuBar) => {
            if (!quill) {
                return;
            }

            const selection = quill.getSelection();
            if (!selection) {
                return;
            }

            const format = quill.getFormat();
            if (!format) {
                return;
            }

            if (format.hasOwnProperty(Constants.quillFormatKeywords.fontSize) && (typeof format.fs === 'string')) {
                let currentFontSize = format.fs;
                if (currentFontSize.endsWith('pt')) {
                    currentFontSize = currentFontSize.slice(0, -2);
                }
                const currentFontSizeIndex = Constants.fontSizes.findIndex((v) => v === currentFontSize);
                if (currentFontSizeIndex > -1) {
                    const nextFontSize = (currentFontSizeIndex === Constants.fontSizes.length - 1) ? Constants.fontSizes[0] : Constants.fontSizes[currentFontSizeIndex + 1];
                    setFontSize(quill, nextFontSize, setFormatMenuBar);
                }
            }
        },
        decreaseFontSize: (quill, setFormatMenuBar) => {
            if (!quill) {
                return;
            }

            const selection = quill.getSelection();
            if (!selection) {
                return;
            }

            const format = quill.getFormat();
            if (!format) {
                return;
            }

            if (format.hasOwnProperty(Constants.quillFormatKeywords.fontSize) && (typeof format.fs === 'string')) {
                let currentFontSize = format.fs;
                if (currentFontSize.endsWith('pt')) {
                    currentFontSize = currentFontSize.slice(0, -2);
                }
                const currentFontSizeIndex = Constants.fontSizes.findIndex((v) => v === currentFontSize);
                if (currentFontSizeIndex > -1) {
                    const nextFontSize = (currentFontSizeIndex === 0) ? Constants.fontSizes[Constants.fontSizes.length - 1] : Constants.fontSizes[currentFontSizeIndex - 1];
                    setFontSize(quill, nextFontSize, setFormatMenuBar);
                }
            }
        },
        formatBackgroundColor: (quill, start, length, color) => {
            quill.formatText(start, length, {
                'background-color': color,
                'border-radius': '5px'
            }, true);
        },
        undo: (quill, setFormatMenuBar) => {
            if (!quill) {
                return;
            }

            // This will be enhanced by BaseLayout integration
            // For now, just trigger document-level undo
            const event = new CustomEvent('webeditor-undo');
            window.dispatchEvent(event);
        },
        redo: (quill, setFormatMenuBar) => {
            if (!quill) {
                return;
            }

            // This will be enhanced by BaseLayout integration
            // For now, just trigger document-level redo
            const event = new CustomEvent('webeditor-redo');
            window.dispatchEvent(event);
        }
    }
}

function createUnorderedList(quill) {
    quill.format(Constants.quillFormatKeywords.list, Constants.quillFormatKeywords.bullet);
    quill.format(Constants.quillFormatKeywords.align, Constants.quillFormatKeywords.alignLeft);
}

function createNumberedList(quill) {
    quill.format(Constants.quillFormatKeywords.list, Constants.quillFormatKeywords.ordered);
    quill.format(Constants.quillFormatKeywords.align, Constants.quillFormatKeywords.alignLeft);
}

function setFontSize(quill, fontSize, setFormatMenuBar) {
    if (!quill) {
        return;
    }

    const selection = quill.getSelection();
    if (!selection) {
        return;
    }

    const format = quill.getFormat();
    if (!format) {
        return;
    }

    quill.format(Constants.quillFormatKeywords.fontSize, `${fontSize}pt`);

    setFormatMenuBar(prev => ({
        ...prev,
        fontSizeButtonValue: fontSize,
    }))
}
